import { GameObject } from "../core/GameObject";
import ResizableScene from "../core/ResizableScene";

export class TapHand extends GameObject {
    handImage: Phaser.GameObjects.Image;

    constructor(scene: ResizableScene) {
        super(scene)
        const tutHand =  this.handImage = this.addImage("tutHand");
		tutHand.setOrigin(10 / tutHand.width, 100 / tutHand.height);
		tutHand.angle = 45;
		scene.tweens.add({
			targets: tutHand,
			scale: 1.2,
			ease: Phaser.Math.Easing.Quadratic.Out,
			yoyo: true,
			duration: 500,
			loop: -1,
		});
    }

    dismiss(): void {
        this.scene.tweens.add({
            targets: this.handImage,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 350,
            onComplete: ()=> { this.destroy(); }
        });
    }
}